const { UserActionsMixpanelEvents } = require('./userActions');

const MixpanelEvents = {
    userActions: UserActionsMixpanelEvents
};

module.exports = {
    MixpanelEvents
};
